<template>
    <div v-if="isloaded">

        <div class="container mt-5 mb-5">
                <mdb-accordion :panes="icerik" material></mdb-accordion>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import { mdbAccordion, mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption,mdbCollapse } from 'mdbvue';
    import searchBar from '@/components/searchBar';

    export default {
        metaInfo() {
            return {
                title: "Sıkça Sorulan Sorular",
                meta: [
                    { name: 'description', content:  "Fiyatlarımız ve uçuş noktalarımız dinamik olup sürekli yenilendikleri için en güncel fiyatları görebilmeniz açısından sitemizi sık sık ziyaret etmenizi tavsiye ederiz."},
                    { name: 'keywords', content:  ""},
                    { property: 'og:title', content: "Sıkça Sorulan Sorular"},
                    { property: 'og:site_name', content: 'Biletbul'},
                    {property: 'og:type', content: 'website'},
                    {name: 'robots', content: 'index,follow'}
                ]
            }
        },
        components: {
            mdbAccordion,
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbTabs,
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbBtn,
            mdbTextarea,
            mdbInput,
            mdbCarouselItem,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCarousel,
            mdbCarouselCaption,
            mdbCollapse,
            'bb-searchbar':searchBar,
        },
        data() {
            return {
                modal: false,
                toggle: false,
                slug:this.$route.params.slug,
                isloaded : true,
                icerik:[
                    {
                        title:"WWW.BILETBUL.COM NASIL HİZMET VERMEKTEDİR?",
                        content:"Amacımız, anlaşmalı havayollarımız ile birlikte sınırlı bir süre için geçerli en indirimli fiyatları sunmak. Fiyatlarımız ve uçuş noktalarımız dinamik olup sürekli yenilendikleri için en güncel fiyatları görebilmeniz açısından sitemizi sık sık ziyaret etmenizi tavsiye ederiz. Böylece her zaman cazip fiyatlarla karşılaşabilirsiniz"
                    },
                    {
                        title:"HANGI HAVAYOLLARI ILE SEYAHAT EDEBILIRIM?",
                        content:"Tüm uçuşlarınız Uluslararası Hava Taşımacılığı Birliği, IATA üyesi ulusal havayolu şirketlerinin tarifeli uçuşları ve içhat havayollarının tarifeli seferleridir."
                    },
                    {
                        title: "YER OLUP OLMADIĞINI NASIL ÖĞRENEBILIRIM?",
                        content: "Gideceğiniz şehre hangi uçakların olduğunu, bunların gün ve saatlerini ve bu uçaklarda yer olup olmadığını, hiç bir satın alma taahhütüne girmeden öğrenebilirsiniz. Arama alanına gitmek istediğiniz şehri girerek veya \"uçuş bul\" butonunu tıkladığınızda sitemiz sizi yönlendirerek bir kaç adımda o şehre hangi havayollarının uçuşların olduğunu, saatlerini, fiyatlarını ve yer olup olmadığını gösterecektir. Şayet bu listede size uygun bir uçuş bulursanız rezervasyon aşamasına geçebilirsiniz. Rezervasyon sonucunda size detaylı güzergah ve fiyat bilgisi verilecektir. Bu aşamada isterseniz biletinizi satın alır, istemezseniz ön rezervasyon yapıp sistemin size vermiş olduğu opsiyon süresine kadar karar verebilirsiniz. Satın alınmayan ön rezervasyonlar otomatik olarak iptal edilecektir. Önemli not: Ön rezervasyon yapıldığında opsiyon süreniz sabit kalmak şartı ile havayolu rezervasyona ek ücret ekleme (vergi veya ek hizmet bedeli gibi) hakkını saklı tutar"
                    },
                    {
                        title: "İSTEDIĞIM DETAYLARDA YER BULAMIYORUM?",
                        content: "Biletbul’un sunduğu indirimli ürünler ve fiyatları her gün değişmektedir. Doğal olarak her zaman her ihtiyacınıza cevap veremeyebiliriz. Biz sizler için son dakikada oluşan en cazip fiyatları seçiyor ve bunları sunuyoruz. Şayet sizin gitmek istediğiniz noktaya o tarih için özel fiyatlı bir uçuş göstermiyorsak , bunun nedeni özel fiyatımız olan uçuşlarda boş yer kalmamış olmasıdır. Ancak uçaklarda son dakikada yer açıldığında anında sitemize yansıyor. Bu nedenle sitemizi sık sık ziyaret etmenizi öneririz."
                    },
                    {
                        title: "NELERE DIKKAT ETMELIYIM?",
                        content: "Rezervasyon yaparken veya bilet satın alırken dikkat etmeniz gereken en önemli konu mükerrer olmamasıdır.Örnek olarak; daha önce havayolundan veya başka bir acenteden yapılmış olan ön rezervasyon veya satın alınmış bilet varsa ve aynı detaylarda biletbul.com sitesinden işlem yaptığınızda Havayolları yapılmış olan işlemi mükerrer sayacak ve rezervasyon veya bileti iptal edecektir. Bundan dolayı işlem yaparken başka bir yerden işlem yapmadığınızdan emin olmanız gerekmektedir."
                    },
                    {
                        title: "ELEKTRONIK BILET ( E-BILET ) NEDIR?",
                        content: "Kağıt bilet kullanımını ortadan kaldıran biletleme sistemidir. Tüm bilet bilgileri elektronik olarak sistemde saklanır ve satış anında size tüm bilgileri içeren bir \"seyahat belgesi\" verilir. Rezervasyon ve ödeme, kağıt bilette olduğu gibi devam eder ve size verilen seyahat belgesi olsun ya da olmasın, check-in kontuarında uluslar arası uçuşlarda Pasaport ile, yurtiçi uçuşlarda ise Nüfus cüzdanı veya Pasaport ile birlikte check-in yaptırabilirsiniz."
                    },
                    {
                        title: "KAĞIT BILET OLMADAN ( E-BILET ILE ) NASIL UÇABILIRIM?",
                        content: "Satış anında size verilen \"seyahat belgesi\" rezervasyon ve uçuşla ilgili tüm gerekli bilgileri konfirme eden bir belgedir, bu nedenle havalimanında direk check-in kontuarına gidip uçuş yapabilirsiniz."
                    },
                    {
                        title: "ELEKTRONIK BILET ( E-BILET ) KULLANMANIN AVANTAJLARI NELERDIR?",
                        content: "Elektronik biletin(e-bilet) kaybolma, çalınma ve unutulma riski yoktur. Rezervasyondan boarding ve uçuş aşamasına kadar tüm bilet işlemlerinin daha pratik, hızlı ve sorunsuz gerçekleşmesini sağlar."
                    },
                    {
                        title: "ELEKTRONIK BILETIN IADESI KAĞIT BILETIN IADESINDEN FARKLI MIDIR?",
                        content: "Kağıt bilet için uygulanan iade kurallarımız elektronik bilet(e-bilet) için de aynen geçerlidir. İadesi talep edilen kağıt bilet eğer kaybedilmişse, iadenin yapılabilmesi için öncelikle kayıp bilet araştırması yapılmalı ve işlemler tamamlandıktan sonra söz konusu biletin iadesi yapılabilmektedir. Halbuki, tüm bilet bilgilerinin sistemde kayıtlı olduğu elektronik bilette(e-bilette), biletin kaybolma tehlikesi olmadığından, zaman kaybetmeksizin iade işlemi gerçekleştirilmektedir."
                    },
                    {
                        title: "UÇAK BILETIMI WWW.BILETBUL.COM SITESINDEN NASIL SATIN ALABILIRIM?",
                        content: "Web sitemizden, elektronik Bilet ( e-bilet ) düzenlenmesine uygun uçuşlar için biletinizi ücretinizi web sitemiz aracılığıyla KREDİ KARTI ile veya EFT-HAVALE yoluyla ödemeniz halinde Elektronik Bilet düzenlenip tarafınıza seyahat belgeniz e-mail ile yollanacaktır."
                    },
                    {
                        title: "BILET İPTAL-İADE KURALLARI NELERDIR?",
                        content: "Web sitemiz aracılığı ile satın alınan biletlerin iptal, iade ve değişiklik talepleri için, Çağrı merkezimiz 0850 228 2004 numaralı telefondan arayabilirsiniz."
                    },
                    {
                        title: "HIZMET BEDELI NEDIR, NASIL UYGULANMAKTADIR?",
                        content: "Hizmet Bedeli, Türkiye'deki Havayolları ve Seyahat Acentelerinin 01/04/2007 itibariyle yasa ile beraber uygulanmaya başlanılan ve her bilet başına tahsil edilen bir bedeldir. Biletin İptal veya iadesi durumunda hizmet bedeli iade edilmemektedir."
                    }
                    ],
            };
        },
        mounted() {

        },
        methods:{

        },
        watch:{

        }
    };
</script>

<style scoped>
.rotate-icon{
    float: right;
}
</style>
